export const getUrl = (obj: any, key: string): string | null => {
  if (obj && Object.prototype.hasOwnProperty.call(obj, key) && obj[key]?.url) {
    return obj[key].url;
  }
  return null;
};
